import * as yup from 'yup';

export interface InviteUserFormData {
  email: string;
  role: number | null;
  isBookingWork: boolean;
}

export const inviteUserSchema: yup.ObjectSchema<InviteUserFormData> = yup
  .object()
  .shape({
    email: yup
      .string()
      .required('Email is required')
      .email('Please enter a valid email address')
      .trim(),
    role: yup
      .number()
      .nullable()
      .required('A role must be selected')
      .typeError('A role must be selected'),
    isBookingWork: yup.boolean().required().default(true),
  });
